import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** https://jira.vk.team/browse/CLOUDWEB-17706 Фильтрация пабликов в документах. С вами поделились */
export const SHARED_WITH_YOU_ALLDOCS_CATEGORY_ENABLED = isFeature('shared-with-you-alldocs-category-enabled');
